"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isSoilTypesLoaded = isSoilTypesLoaded;
exports.isProjectsLoaded = isProjectsLoaded;
exports.isProjectLoaded = isProjectLoaded;
exports.loadProjectUsers = loadProjectUsers;
exports.loadProjectInactiveUsers = loadProjectInactiveUsers;
exports.loadProjects = loadProjects;
exports.loadProject = loadProject;
exports.createProject = createProject;
exports.updateProject = updateProject;
exports.resetCreateProject = resetCreateProject;
exports.resetProjectAdDrivers = resetProjectAdDrivers;
exports.resetUpdateProject = resetUpdateProject;
exports.addProjectUserEmail = addProjectUserEmail;
exports.updateProjectUserByEmail = updateProjectUserByEmail;
exports.updateProjectDriverByEmail = updateProjectDriverByEmail;
exports.addDriverToAd = addDriverToAd;
exports.removeDriverFromAd = removeDriverFromAd;
exports.projectGetDrivers = projectGetDrivers;
exports.projectAdGetDrivers = projectAdGetDrivers;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CREATE_PROJECT = "maaporssi/projects/CREATE_PROJECT";
var CREATE_PROJECT_FAIL = "maaporssi/projects/CREATE_PROJECT_FAIL";
var CREATE_PROJECT_SUCCESS = "maaporssi/projects/CREATE_PROJECT_SUCCESS";
var CREATE_PROJECT_RESET = "maaporssi/projects/CREATE_PROJECT_RESET";

var UPDATE_PROJECT = "maaporssi/projects/UPDATE_PROJECT";
var UPDATE_PROJECT_FAIL = "maaporssi/projects/UPDATE_PROJECT_FAIL";
var UPDATE_PROJECT_SUCCESS = "maaporssi/projects/UPDATE_PROJECT_SUCCESS";
var UPDATE_PROJECT_RESET = "maaporssi/projects/UPDATE_PROJECT_RESET";

var LOAD_PROJECTS = "maaporssi/projects/LOAD_PROJECTS";
var LOAD_PROJECTS_SUCCESS = "maaporssi/projects/LOAD_PROJECTS_SUCCESS";
var LOAD_PROJECTS_FAIL = "maaporssi/projects/LOAD_PROJECTS_FAIL";

var LOAD_PROJECT = "maaporssi/projects/LOAD_PROJECT";
var LOAD_PROJECT_SUCCESS = "maaporssi/projects/LOAD_PROJECT_SUCCESS";
var LOAD_PROJECT_FAIL = "maaporssi/projects/LOAD_PROJECT_FAIL";

var LOAD_PROJECT_USERS = "maaporssi/projects/LOAD_PROJECT_USERS";
var LOAD_PROJECT_USERS_SUCCESS = "maaporssi/projects/LOAD_PROJECT_USERS_SUCCESS";
var LOAD_PROJECT_USERS_FAIL = "maaporssi/projects/LOAD_PROJECT_USERS_FAIL";

var LOAD_PROJECT_INACTIVE_USERS = "maaporssi/projects/LOAD_PROJECT_INACTIVE_USERS";
var LOAD_PROJECT_INACTIVE_USERS_SUCCESS = "maaporssi/projects/LOAD_PROJECT_INACTIVE_USERS_SUCCESS";
var LOAD_PROJECT_INACTIVE_USERS_FAIL = "maaporssi/projects/LOAD_PROJECT_INACTIVE_USERS_FAIL";

var CREATE_PROJECT_USER = "maaporssi/projects/CREATE_PROJECT_USER";
var CREATE_PROJECT_USER_FAIL = "maaporssi/projects/CREATE_PROJECT_USER_FAIL";
var CREATE_PROJECT_USER_SUCCESS = "maaporssi/projects/CREATE_PROJECT_USER_SUCCESS";
var CREATE_PROJECT_USER_RESET = "maaporssi/projects/CREATE_PROJECT_USER_RESET";

var ADD_PROJECT_USERS_EMAIL = "maaporssi/projects/ADD_PROJECT_USERS_EMAIL";
var ADD_PROJECT_USERS_EMAIL_FAIL = "maaporssi/projects/ADD_PROJECT_USERS_EMAIL_FAIL";
var ADD_PROJECT_USERS_EMAIL_SUCCESS = "maaporssi/projects/ADD_PROJECT_USERS_EMAIL_SUCCESS";

var UPDATE_PROJECT_DRIVER_BY_EMAIL = "maaporssi/projects/UPDATE_PROJECT_DRIVER_BY_EMAIL";
var UPDATE_PROJECT_DRIVER_BY_EMAIL_FAIL = "maaporssi/projects/UPDATE_PROJECT_DRIVER_BY_EMAIL_FAIL";
var UPDATE_PROJECT_DRIVER_BY_EMAIL_SUCCESS = "maaporssi/projects/UPDATE_PROJECT_DRIVER_BY_EMAIL_SUCCESS";

var UPDATE_PROJECT_USERS_BY_EMAIL = "maaporssi/projects/UPDATE_PROJECT_USERS_BY_EMAIL";
var UPDATE_PROJECT_USERS_BY_EMAIL_FAIL = "maaporssi/projects/UPDATE_PROJECT_USERS_BY_EMAIL_FAIL";
var UPDATE_PROJECT_USERS_BY_EMAIL_SUCCESS = "maaporssi/projects/UPDATE_PROJECT_USERS_BY_EMAIL_SUCCESS";

var ADD_DRIVER_TO_AD = "maaporssi/projects/ADD_DRIVER_TO_AD";
var ADD_DRIVER_TO_AD_FAIL = "maaporssi/projects/ADD_DRIVER_TO_AD_FAIL";
var ADD_DRIVER_TO_AD_SUCCESS = "maaporssi/projects/ADD_DRIVER_TO_AD_SUCCESS";

var REMOVE_DRIVER_FROM_AD = "maaporssi/projects/REMOVE_DRIVER_FROM_AD";
var REMOVE_DRIVER_FROM_AD_FAIL = "maaporssi/projects/REMOVE_DRIVER_FROM_AD_FAIL";
var REMOVE_DRIVER_FROM_AD_SUCCESS = "maaporssi/projects/REMOVE_DRIVER_FROM_AD_SUCCESS";

var LOAD_PROJECT_AD_DRIVERS = "maaporssi/projects/LOAD_PROJECT_AD_DRIVERS";
var LOAD_PROJECT_AD_DRIVERS_SUCCESS = "maaporssi/projects/LOAD_PROJECT_AD_DRIVERS_SUCCESS";
var LOAD_PROJECT_AD_DRIVERS_FAIL = "maaporssi/projects/LOAD_PROJECT_AD_DRIVERS_FAIL";
var LOAD_PROJECT_AD_DRIVERS_RESET = "maaporssi/projects/LOAD_PROJECT_AD_DRIVERS_RESET";

var LOAD_PROJECT_DRIVERS = "maaporssi/projects/LOAD_PROJECT_DRIVERS";
var LOAD_PROJECT_DRIVERS_SUCCESS = "maaporssi/projects/LOAD_PROJECT_DRIVERS_SUCCESS";
var LOAD_PROJECT_DRIVERS_FAIL = "maaporssi/projects/LOAD_PROJECT_DRIVERS_FAIL";
var LOAD_PROJECT_DRIVERS_RESET = "maaporssi/projects/LOAD_PROJECT_DRIVERS_RESET";

var initialState = {
  projectsLoaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_PROJECT_DRIVERS:
      return (0, _extends3.default)({}, state, {
        loadProjectDriversLoading: true
      });
    case LOAD_PROJECT_DRIVERS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadProjectDriversLoading: false,
        loadProjectDriversSuccess: false,
        error: action.error.error
      });
    case LOAD_PROJECT_DRIVERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadProjectDriversLoading: false,
        loadProjectDriversSuccess: true,
        projectDrivers: action.result
      });
    case LOAD_PROJECT_DRIVERS_RESET:
      return (0, _extends3.default)({}, state, {
        loadProjectDriversLoading: false,
        loadProjectDriversSuccess: false,
        error: null

      });
    case LOAD_PROJECT_AD_DRIVERS:
      return (0, _extends3.default)({}, state, {
        loadProjectAdDriversLoading: true
      });
    case LOAD_PROJECT_AD_DRIVERS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadProjectAdDriversLoading: false,
        loadProjectAdDriversSuccess: false,
        error: action.error.error
      });
    case LOAD_PROJECT_AD_DRIVERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loadProjectAdDriversLoading: false,
        loadProjectAdDriversSuccess: true,
        projectAdDrivers: action.result
      });
    case LOAD_PROJECT_AD_DRIVERS_RESET:
      return (0, _extends3.default)({}, state, {
        loadProjectAdDriversLoading: false,
        loadProjectAdDriversSuccess: false,
        projectAdDrivers: null,
        error: null

      });

    case ADD_DRIVER_TO_AD:
      return (0, _extends3.default)({}, state, {
        addDriverToAdLoading: true
      });
    case ADD_DRIVER_TO_AD_FAIL:
      return (0, _extends3.default)({}, state, {
        addDriverToAdLoading: false,
        addDriverToAdSuccess: false,
        error: action.error.error
      });
    case ADD_DRIVER_TO_AD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        addDriverToAdLoading: false,
        addDriverToAdSuccess: true,
        addedDrivers: action.result
      });

    case REMOVE_DRIVER_FROM_AD:
      return (0, _extends3.default)({}, state, {
        Loading: true
      });
    case REMOVE_DRIVER_FROM_AD_FAIL:
      return (0, _extends3.default)({}, state, {
        removeDriverFromAdLoading: false,
        removeDriverFromAdSuccess: false,
        error: action.error.error
      });
    case REMOVE_DRIVER_FROM_AD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        removeDriverFromAdLoading: false,
        removeDriverFromAdSuccess: true,
        removedDriver: action.result
      });

    case UPDATE_PROJECT_DRIVER_BY_EMAIL:
      return (0, _extends3.default)({}, state, {
        updateProjectDriverEmailLoading: true
      });
    case UPDATE_PROJECT_DRIVER_BY_EMAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        updateProjectDriverEmailLoading: false,
        updateProjectDriverEmailSuccess: false,
        error: action.error.error
      });
    case UPDATE_PROJECT_DRIVER_BY_EMAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updateProjectDriverEmailLoading: false,
        updateProjectDriverEmailSuccess: true,
        userEmail: action.result
      });
    case UPDATE_PROJECT_USERS_BY_EMAIL:
      return (0, _extends3.default)({}, state, {
        updateProjectUserByEmailLoading: true
      });
    case UPDATE_PROJECT_USERS_BY_EMAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        updateProjectUserByEmailLoading: false,
        updateProjectUserByEmailSuccess: false,
        error: action.error.error
      });
    case UPDATE_PROJECT_USERS_BY_EMAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updateProjectUserByEmailLoading: false,
        updateProjectUserByEmailSuccess: true,
        userEmail: action.result
      });

    case ADD_PROJECT_USERS_EMAIL:
      return (0, _extends3.default)({}, state, {
        projectUsersEmailLoading: true
      });
    case ADD_PROJECT_USERS_EMAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        projectUsersEmailLoading: false,
        projectUsersEmailSuccess: false,
        error: action.error.error
      });
    case ADD_PROJECT_USERS_EMAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        projectUsersEmailLoading: false,
        projectUsersEmailSuccess: true,
        userEmail: action.result
      });

    case CREATE_PROJECT:
      return (0, _extends3.default)({}, state, {
        createProjectLoading: true
      });
    case CREATE_PROJECT_FAIL:
      return (0, _extends3.default)({}, state, {
        createProjectLoading: false,
        createProjectSuccess: false,
        createProjectError: action.error.error
      });
    case CREATE_PROJECT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        newProject: action.result,
        createProjectLoading: false,
        createProjectSuccess: true,
        createProjectError: null
      });
    case CREATE_PROJECT_RESET:
      return (0, _extends3.default)({}, state, {
        createProjectLoading: false,
        createProjectSuccess: false,
        createProjectError: null
      });

    case UPDATE_PROJECT:
      return (0, _extends3.default)({}, state, {
        updateProjectLoading: true
      });
    case UPDATE_PROJECT_FAIL:
      return (0, _extends3.default)({}, state, {
        updateProjectLoading: false,
        updateProjectSuccess: false,
        updateProjectError: action.error.error
      });
    case UPDATE_PROJECT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        editedProject: action.result,
        updateProjectLoading: false,
        updateProjectSuccess: true,
        updateProjectError: null,
        projects: state.projects.map(function (proj) {
          if (proj.id === action.result.id) {
            return (0, _assign2.default)({}, action.result, { isLoaded: true, editable: true });
          } else {
            return proj;
          }
        })
      });
    case UPDATE_PROJECT_RESET:
      return (0, _extends3.default)({}, state, {
        updateProjectLoading: false,
        updateProjectSuccess: false,
        updateProjectError: null
      });

    case LOAD_PROJECTS:
      return (0, _extends3.default)({}, state, {
        projectsLoading: true
      });
    case LOAD_PROJECTS_FAIL:
      return (0, _extends3.default)({}, state, {
        projectsLoading: false,
        projectsLoaded: true,
        projectsError: action.error.error
      });
    case LOAD_PROJECTS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        projectsLoading: false,
        projectsLoaded: true,
        projectsError: null,
        projects: action.result
      });

    case LOAD_PROJECT:
      return (0, _extends3.default)({}, state, {
        projectLoading: true
      });
    case LOAD_PROJECT_FAIL:
      return (0, _extends3.default)({}, state, {
        projectLoading: false,
        projectError: action.error.error
      });
    case LOAD_PROJECT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        project: action.result,
        projectLoading: false,
        projectError: null
      });
    case LOAD_PROJECT_USERS:
      return (0, _extends3.default)({}, state, {
        loadProjectUsersLoading: true,
        loadProjectUsersSuccess: false

      });
    case LOAD_PROJECT_USERS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadProjectUsersLoading: false,
        loadProjectUsersError: action.error.error,
        loadProjectUsersSuccess: true

      });
    case LOAD_PROJECT_USERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        projectUsers: action.result,
        loadProjectUsersLoading: false,
        loadProjectUsersError: null,
        loadProjectUsersSuccess: true

      });

    case LOAD_PROJECT_INACTIVE_USERS:
      return (0, _extends3.default)({}, state, {
        loadProjectInactiveUsersLoading: true,
        isProjectInactiveUsersLoaded: false

      });
    case LOAD_PROJECT_INACTIVE_USERS_FAIL:
      return (0, _extends3.default)({}, state, {
        loadProjectInactiveUsersLoading: false,
        loadProjectInactiveUsersError: action.error.error,
        isProjectInactiveUsersLoaded: true

      });
    case LOAD_PROJECT_INACTIVE_USERS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        projectInactiveUsers: action.result,
        loadProjectInactiveUsersLoading: false,
        loadProjectInactiveUsersError: null,
        isProjectInactiveUsersLoaded: true
      });

    default:
      return state;
  }
}

function isSoilTypesLoaded(globalState) {
  return globalState.ads && globalState.ads.soilTypesLoaded;
}

function isProjectsLoaded(globalState) {
  return globalState.projects && globalState.projects.projectsLoaded;
}

function isProjectLoaded(projctId, globalState) {
  var projects = globalState && globalState.projects && globalState.projects.projects;
  if (projects && projects.length) {
    return projects.some(function (proj) {
      return proj.id === projId && proj.isLoaded;
    });
  }
}

function loadProjectUsers(project_id) {
  return {
    types: [LOAD_PROJECT_USERS, LOAD_PROJECT_USERS_SUCCESS, LOAD_PROJECT_USERS_FAIL],
    promise: function promise(client) {
      return client.get("/project-users-list/" + project_id);
    }
  };
}

function loadProjectInactiveUsers(project_id) {
  return {
    types: [LOAD_PROJECT_INACTIVE_USERS, LOAD_PROJECT_INACTIVE_USERS_SUCCESS, LOAD_PROJECT_INACTIVE_USERS_FAIL],
    promise: function promise(client) {
      return client.get("/inactive-users-list/" + project_id);
    }
  };
}

function loadProjects(user_id) {
  return {
    types: [LOAD_PROJECTS, LOAD_PROJECTS_SUCCESS, LOAD_PROJECTS_FAIL],
    promise: function promise(client) {
      return client.get("/projectlists/" + user_id);
    }
  };
}

function loadProject(id) {
  return {
    types: [LOAD_PROJECT, LOAD_PROJECT_SUCCESS, LOAD_PROJECT_FAIL],
    promise: function promise(client) {
      return client.get("/projects/" + id);
    }
  };
}

function createProject(formData) {
  return {
    types: [CREATE_PROJECT, CREATE_PROJECT_SUCCESS, CREATE_PROJECT_FAIL],
    promise: function promise(client) {
      return client.post("/project", {
        data: formData
      });
    }
  };
}

function updateProject(userId, projectId, formData) {
  return {
    types: [UPDATE_PROJECT, UPDATE_PROJECT_SUCCESS, UPDATE_PROJECT_FAIL],
    promise: function promise(client) {
      return client.post("/projects/" + userId + "/" + projectId + "/update", {
        data: formData
      });
    }
  };
}

function resetCreateProject() {
  return {
    type: CREATE_PROJECT_RESET
  };
}
function resetProjectAdDrivers() {
  return {
    type: LOAD_PROJECT_AD_DRIVERS_RESET
  };
}

function resetUpdateProject() {
  return {
    type: UPDATE_PROJECT_RESET
  };
}

function addProjectUserEmail(user_id, data) {
  //  console.info('project.js addProjectUserEmail', data);
  var formData = {
    projectId: data.projectId,
    email: data.email,
    is_admin: data.is_admin,
    is_project_editor: data.is_project_editor,
    is_driver: data.is_driver
  };

  return {
    types: [ADD_PROJECT_USERS_EMAIL, ADD_PROJECT_USERS_EMAIL_SUCCESS, ADD_PROJECT_USERS_EMAIL_FAIL],
    //  promise: (client) => client.post (`/project-users-add/${projectId}/${emailId}`)

    promise: function promise(client) {
      return client.post("/project-users-add/" + user_id, {
        data: formData
      });
    }
  };
}

function updateProjectUserByEmail(data) {
  return {
    types: [UPDATE_PROJECT_USERS_BY_EMAIL, UPDATE_PROJECT_USERS_BY_EMAIL_SUCCESS, UPDATE_PROJECT_USERS_BY_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post("/project-users-update/", {
        data: data
      });
    }
  };
}

function updateProjectDriverByEmail(data) {
  return {
    types: [UPDATE_PROJECT_DRIVER_BY_EMAIL, UPDATE_PROJECT_DRIVER_BY_EMAIL_SUCCESS, UPDATE_PROJECT_DRIVER_BY_EMAIL_FAIL],
    promise: function promise(client) {
      return client.post("/project-driver-update/", {
        data: data
      });
    }
  };
}

function addDriverToAd(data) {

  var formData = {
    useNewVersion: data.useNewVersion,
    user_id: data.user_id,
    project_id: data.project_id,
    email: data.email,
    ad_id: data.ad_id,
    phone: data.phone
  };

  return {
    types: [ADD_DRIVER_TO_AD, ADD_DRIVER_TO_AD_SUCCESS, ADD_DRIVER_TO_AD_FAIL],
    promise: function promise(client) {
      return client.post("/project-ad-driver-add/", {
        data: formData
      });
    }
  };
}
// project-ad-driver-remove
function removeDriverFromAd(data) {

  var formData = {
    useNewVersion: data.useNewVersion,
    user_id: data.user_id,
    project_id: data.project_id,
    ad_id: data.ad_id
  };

  return {
    types: [REMOVE_DRIVER_FROM_AD, REMOVE_DRIVER_FROM_AD_SUCCESS, REMOVE_DRIVER_FROM_AD_FAIL],
    promise: function promise(client) {
      return client.post("/project-ad-driver-remove/", {
        data: formData
      });
    }
  };
}

function projectGetDrivers(project_id) {
  return {
    types: [LOAD_PROJECT_DRIVERS, LOAD_PROJECT_DRIVERS_SUCCESS, LOAD_PROJECT_DRIVERS_FAIL],
    promise: function promise(client) {
      return client.get("/project-drivers-list/" + project_id);
    }
  };
}

function projectAdGetDrivers(ad_id) {
  return {
    types: [LOAD_PROJECT_AD_DRIVERS, LOAD_PROJECT_AD_DRIVERS_SUCCESS, LOAD_PROJECT_AD_DRIVERS_FAIL],
    promise: function promise(client) {
      return client.get("/load-project-ad-drivers/" + ad_id);
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/projects.js
 ** module id = 76
 ** module chunks = 0
 **/